// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_DL97V {
  width: 100%;
  margin: 0 auto;
  max-width: 1000px;
  padding: 20px 10px 0 10px;
  font-family: "Inter", sans-serif;
  max-height: 97vh;
  overflow-y: auto;
  box-sizing: border-box;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: var(--white-color);
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
}

.container_DL97V::-webkit-scrollbar {
  display: none;
}
@media (width <= 768px) {
  .showInfoMobileBill_Dq_Nr {
    position: absolute;
    width: 100vw;
    max-width: 100vw;
    z-index: 3;
    background-color: var(--white-color);
  }
}
.header_GKSIu {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  flex-wrap: wrap;
  gap: 10px;
  border-bottom: 1px solid #11a3813c;
  position: relative;
}

.addNote_Btj_A {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .button_AtmqU {
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
    width: fit-content;
  }

  .note_vseUH {
    background-color: var(--_c2f2d3-background);
    border: 1px solid var(--_0000001d-border);
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    .text_qzaJq {
      min-height: 40px;
      height: fit-content;
      max-height: 100px;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    span,
    input {
      background-color: transparent;
      font-family: "Inter", sans-serif;
      font-size: 13px;
    }
    input {
      background-color: var(--_9bd8b1fd-background);
      border: none;
    }
  }

}

.titleWrapper_ZnOtO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  div {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      width: 16px;
      height: 22px;
    }
  }
  button {
    border: none;
    outline: none;
    background-color: transparent;
    text-decoration: underline;
    color: var(--_2-color);
    font-weight: bold;
  }
  button:disabled {
    color: var(--_b4-color);
  }
}

.dropdownContainer_Ow0yn {
  display: flex;
  gap: 20px;
  width: 100%;
}
.dropdownsLeft_RzjWI {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
}

.chevronIcon_ZPpy8 {
  height: 10px;
  width: 10px;
}

.dropdown_xOhWL {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: var(--_7e-color);
  height: 35px;
  background: var(--f4-background);
  padding: 0px 12px;
  height: 31px;
  border-radius: 4px;
  justify-content: flex-start;
  cursor: pointer;
  gap: 10px;
  text-transform: capitalize;
  width: 100%;
  justify-content: space-between;
  p{
    font-size: 13px;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: var(--_7e-color);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.titleContent_A49JZ {
  width: 100%;
}

.title_LDiHI {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: var(--_084437-color);
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  border: none;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  background-color: var(--f4-background);
  outline: none;
}

.title_LDiHI::placeholder {
  color: var(--_71717a-color);
}

.btnSectionsSelector_pxuRx {
  background-color: var(--f9-background);
  display: flex;
  padding: 4px;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;
  button {
    flex: 1 1;
    padding: 12px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    border: 1px solid transparent;
    background-color: transparent;
    color: var(--_b4-color);
  }
  .sectionSelect_EcjCt {
    background-color: var(--white-background);
    color: #0d0d0d;
    border: 1px solid #0000002b;
  }
}


.headerBillMobile_GmCqH {
  display: flex;
  justify-content: space-between;
  width: 100px;
  button {
    background-color: transparent;
    outline: none;
    border: none;
    color: var(--_292d32-color);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .notesHeaderBillMobile_spqsN {
    display: flex;
    align-items: center;
    gap: 10px;

    .note_vseUH {
      display: flex;
      padding: 0px 5px;
      align-items: flex-start;
      gap: 3px;
      border-radius: 5px;
      background: #ef0;
    }

    button {
      color: var(--_929598-color);
      font-family: Inter;
      font-size: 8px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; 
    }
  }
}

.verticalOptionDots_WqNZP {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/SelectCategoryAndConcept/SelectCategoryAndConcept.module.css"],"names":[],"mappings":"AAIA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,oCAAoC;EACtC;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,yCAAyC;IACzC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,qBAAqB;MACrB,wBAAwB;MACxB;QACE,aAAa;MACf;IACF;IACA;;MAEE,6BAA6B;MAC7B,gCAAgC;MAChC,eAAe;IACjB;IACA;MACE,6CAA6C;MAC7C,YAAY;IACd;EACF;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,WAAW;MACX,YAAY;IACd;EACF;EACA;IACE,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,8BAA8B;EAC9B;IACE,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;EACzB;EACA;IACE,yCAAyC;IACzC,cAAc;IACd,2BAA2B;EAC7B;AACF;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,aAAa;MACb,gBAAgB;MAChB,uBAAuB;MACvB,QAAQ;MACR,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.container {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1000px;\n  padding: 20px 10px 0 10px;\n  font-family: \"Inter\", sans-serif;\n  max-height: 97vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  background-color: var(--white-color);\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n@media (width <= 768px) {\n  .showInfoMobileBill {\n    position: absolute;\n    width: 100vw;\n    max-width: 100vw;\n    z-index: 3;\n    background-color: var(--white-color);\n  }\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 10px;\n  border-bottom: 1px solid #11a3813c;\n  position: relative;\n}\n\n.addNote {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .button {\n    text-decoration: underline;\n    font-weight: 500;\n    cursor: pointer;\n    width: fit-content;\n  }\n\n  .note {\n    background-color: var(--_c2f2d3-background);\n    border: 1px solid var(--_0000001d-border);\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    .text {\n      min-height: 40px;\n      height: fit-content;\n      max-height: 100px;\n      display: flex;\n      align-items: center;\n      overflow-y: scroll;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    span,\n    input {\n      background-color: transparent;\n      font-family: \"Inter\", sans-serif;\n      font-size: 13px;\n    }\n    input {\n      background-color: var(--_9bd8b1fd-background);\n      border: none;\n    }\n  }\n\n}\n\n.titleWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width: 100%;\n  div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    img {\n      width: 16px;\n      height: 22px;\n    }\n  }\n  button {\n    border: none;\n    outline: none;\n    background-color: transparent;\n    text-decoration: underline;\n    color: var(--_2-color);\n    font-weight: bold;\n  }\n  button:disabled {\n    color: var(--_b4-color);\n  }\n}\n\n.dropdownContainer {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n}\n.dropdownsLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.chevronIcon {\n  height: 10px;\n  width: 10px;\n}\n\n.dropdown {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--_7e-color);\n  height: 35px;\n  background: var(--f4-background);\n  padding: 0px 12px;\n  height: 31px;\n  border-radius: 4px;\n  justify-content: flex-start;\n  cursor: pointer;\n  gap: 10px;\n  text-transform: capitalize;\n  width: 100%;\n  justify-content: space-between;\n  p{\n    font-size: 13px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_7e-color);\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.titleContent {\n  width: 100%;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  color: var(--_084437-color);\n  width: 100%;\n  border-radius: 8px;\n  padding: 6px;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  background-color: var(--f4-background);\n  outline: none;\n}\n\n.title::placeholder {\n  color: var(--_71717a-color);\n}\n\n.btnSectionsSelector {\n  background-color: var(--f9-background);\n  display: flex;\n  padding: 4px;\n  border-radius: 12px;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  -ms-border-radius: 12px;\n  -o-border-radius: 12px;\n  button {\n    flex: 1;\n    padding: 12px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    border: 1px solid transparent;\n    background-color: transparent;\n    color: var(--_b4-color);\n  }\n  .sectionSelect {\n    background-color: var(--white-background);\n    color: #0d0d0d;\n    border: 1px solid #0000002b;\n  }\n}\n\n\n.headerBillMobile {\n  display: flex;\n  justify-content: space-between;\n  width: 100px;\n  button {\n    background-color: transparent;\n    outline: none;\n    border: none;\n    color: var(--_292d32-color);\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; \n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .notesHeaderBillMobile {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    .note {\n      display: flex;\n      padding: 0px 5px;\n      align-items: flex-start;\n      gap: 3px;\n      border-radius: 5px;\n      background: #ef0;\n    }\n\n    button {\n      color: var(--_929598-color);\n      font-family: Inter;\n      font-size: 8px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px; \n    }\n  }\n}\n\n.verticalOptionDots {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_DL97V`,
	"showInfoMobileBill": `showInfoMobileBill_Dq_Nr`,
	"header": `header_GKSIu`,
	"addNote": `addNote_Btj_A`,
	"button": `button_AtmqU`,
	"note": `note_vseUH`,
	"text": `text_qzaJq`,
	"titleWrapper": `titleWrapper_ZnOtO`,
	"dropdownContainer": `dropdownContainer_Ow0yn`,
	"dropdownsLeft": `dropdownsLeft_RzjWI`,
	"chevronIcon": `chevronIcon_ZPpy8`,
	"dropdown": `dropdown_xOhWL`,
	"titleContent": `titleContent_A49JZ`,
	"title": `title_LDiHI`,
	"btnSectionsSelector": `btnSectionsSelector_pxuRx`,
	"sectionSelect": `sectionSelect_EcjCt`,
	"headerBillMobile": `headerBillMobile_GmCqH`,
	"notesHeaderBillMobile": `notesHeaderBillMobile_spqsN`,
	"verticalOptionDots": `verticalOptionDots_WqNZP`
};
export default ___CSS_LOADER_EXPORT___;
